@let navigationItemValue = navigationItem();
@let leftNavigationItemValue = leftNavigationItem();
@let isTooltipEnabledValue = isTooltipEnabled();
@let linkName = 'navigation.items.' + navigationItemValue.id | translate;

<ng-container *itcFeature="navigationItemValue.feature">
  <ng-container *itcCountryAccess="navigationItemValue.accessibleCountries">
    <ng-container *itcPermission="navigationItemValue.permission">
      @if (!navigationItemValue.guard || navigationItemGuard()) {
        @switch (navigationItemValue.type) {
          @case (LeftNavigationItemType.Link) {
            <itc-navigation-link
              [id]="leftNavigationItemValue.id"
              [iconClass]="leftNavigationItemValue.iconClass"
              [linkName]="linkName"
              [isTooltipEnabled]="isTooltipEnabledValue"
              [topNavigation]="topNavigation()"
              (click)="navigationItemClick.emit()"
            />
          }
          @case (LeftNavigationItemType.TaggedLink) {
            <itc-navigation-tagged-link
              [id]="leftNavigationItemValue.id"
              [iconClass]="leftNavigationItemValue.iconClass"
              [linkName]="linkName"
              [isTooltipEnabled]="isTooltipEnabledValue"
              [tagColorVariant]="leftNavigationItemValue.tagColorVariant"
              [tagTextTranslationKey]="leftNavigationItemValue.tagTextTranslationKey"
              [topNavigation]="topNavigation()"
              (click)="navigationItemClick.emit()"
            />
          }
          @case (LeftNavigationItemType.ExternalLink) {
            <itc-navigation-external-link [navigationItem]="leftNavigationExternalItem()" [isTooltipEnabled]="isTooltipEnabledValue" />
          }
          @case (LeftNavigationItemType.ExternalTaggedLink) {
            <itc-navigation-external-tagged-link
              [navigationItem]="leftNavigationExternalItem()"
              [isTooltipEnabled]="isTooltipEnabledValue"
              [tagColorVariant]="leftNavigationItemValue.tagColorVariant"
              [tagTextTranslationKey]="leftNavigationItemValue.tagTextTranslationKey"
            />
          }
        }
      }
    </ng-container>
  </ng-container>
</ng-container>
